import { loadable } from '@shared/core/loadableFromNamedExport';

export const EventPhotoPickerLazy = loadable(() => import(/* webpackChunkName: "admin/EventPhotoPicker" */ './EventPhotoPicker'), 'EventPhotoPicker');
